import React, { useState, useEffect } from 'react';
import './ScrollToTop.css';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Checks how much we scrolled
  const toggleVisibility = () => {
    if (window.pageYOffset > 400) { 
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Jump to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className={`scroll-to-top ${isVisible ? 'show' : ''}`} onClick={scrollToTop}>
      <div className="arrow-up">↑</div>
    </div>
  );
};

export default ScrollToTop;